import { render, staticRenderFns } from "./plantform_new.vue?vue&type=template&id=33105253&scoped=true&"
import script from "./plantform_new.vue?vue&type=script&lang=js&"
export * from "./plantform_new.vue?vue&type=script&lang=js&"
import style0 from "./plantform_new.vue?vue&type=style&index=0&id=33105253&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33105253",
  null
  
)

export default component.exports